import React from "react";

import BasicLoading from "ZeroRuby/BasicLoading";

import { TitleSmall } from "Cobalt/Header";
import { SurfaceSection } from "Cobalt/Surface";
import { Table, TR, TD } from "Cobalt/TableV2";
import { Row, Col } from "Common/Grid";

const LoadingAnimation = () => (
  <div>
    <BasicLoading />
    <div>Loading company information...</div>
  </div>
);

const SyncedPropertiesTable = ({ fields }) => (
  <Table>
    <tbody>
      {fields.map((x, index) => (
        <TR key={`${index}_${x[0]}`} withBorder={false}>
          <TD
            style={{
              width: "40%",
            }}
          >
            {x[0]}
          </TD>
          <TD
            style={{
              width: "60%",
            }}
          >
            {x[1]}
          </TD>
        </TR>
      ))}
    </tbody>
  </Table>
);

type Props = {
  tableHeader?: string;
  sectionTitle?: string;
  isLoading?: boolean;
  syncedProperties: Array<[string, any]>;
  SyncActionComponent?: React.ReactElement<any>;
};

const PartnerSyncedPropertiesSection = ({ tableHeader, sectionTitle = "", isLoading, syncedProperties, SyncActionComponent }: Props) => (
  <SurfaceSection title={sectionTitle}>
    <Row>
      <Col lg={10}>
        <Row>
          {/* Weird double column to allow width to mirror questions which are 7/12 width within lg={10} */}
          <Col sm={7} pl={4} pr={0}>
            {tableHeader ? (
              <TitleSmall mt={0} mb={3}>
                {tableHeader}
              </TitleSmall>
            ) : null}
            {isLoading ? <LoadingAnimation /> : <SyncedPropertiesTable fields={syncedProperties} />}
          </Col>
        </Row>
      </Col>
      {SyncActionComponent && <Col sm={3}>{SyncActionComponent}</Col>}
    </Row>
  </SurfaceSection>
);

export default PartnerSyncedPropertiesSection;
